export default function ({ redirect }) {
  if (process.env.THEME !== 'Britannia') {
    return redirect('/')
  }
}
